import IPlanType from "./plan-type";

export const planData: IPlanType[] = [
  {
    name: "Gratuito",
    price: "R$0",
    packageEnum: "Indicado",
    features: [
      { name: "Portal Lucralize", included: true },
      { name: "Acompanhamento", included: false },
      { name: "Atendimento Via WhatsApp", included: false },
      { name: "Atendimento Telefônico", included: false },
      { name: "Faturamento Mensal", value: "Não disponível" },
      { name: "Emissão de NF/Invoice (Usuário)", value: "Até 5" },
      { name: "Emissão de NF/Invoice (Lucralize)", value: "0" },
      { name: "Sócios", value: "1" },
      { name: "Desconto Curso de Inglês", included: false },
      { name: "Mentoria Mensal Inglês", included: false },
    ],
  },
  {
    name: "Essencial",
    price: "R$189",
    packageEnum: "Essencial",
    features: [
      { name: "Portal Lucralize", included: true },
      { name: "Acompanhamento", included: true },
      { name: "Atendimento Via WhatsApp", included: true },
      { name: "Atendimento Telefônico", included: false },
      { name: "Faturamento Mensal", value: "Até 15k" },
      { name: "Emissão de NF/Invoice (Usuário)", value: "Ilimitado" },
      { name: "Emissão de NF/Invoice (Lucralize)", value: "1" },
      { name: "Sócios", value: "1" },
      { name: "Desconto Curso de Inglês", included: false },
      { name: "Mentoria Mensal Inglês", included: false },
    ],
  },
  {
    name: "Exclusivo",
    price: "R$259",
    packageEnum: "Exclusive",
    features: [
      { name: "Portal Lucralize", included: true },
      { name: "Acompanhamento", included: true },
      { name: "Atendimento Via WhatsApp", included: true },
      { name: "Atendimento Telefônico", included: false },
      { name: "Faturamento Mensal", value: "Até 35k" },
      { name: "Emissão de NF/Invoice (Usuário)", value: "Ilimitado" },
      { name: "Emissão de NF/Invoice (Lucralize)", value: "Até 10" },
      { name: "Sócios", value: "2" },
      { name: "Desconto Curso de Inglês", included: true },
      { name: "Mentoria Mensal Inglês", included: false },
    ],
  },
  {
    name: "Plus",
    price: "R$469",
    packageEnum: "Plus",
    features: [
      { name: "Portal Lucralize", included: true },
      { name: "Acompanhamento", included: true },
      { name: "Atendimento Via WhatsApp", included: true },
      { name: "Atendimento Telefônico", included: true },
      { name: "Faturamento Mensal", value: "Até 100k" },
      { name: "Emissão de NF/Invoice (Usuário)", value: "Ilimitado" },
      { name: "Emissão de NF/Invoice (Lucralize)", value: "Até 30" },
      { name: "Sócios", value: "Ilimitado" },
      { name: "Desconto Curso de Inglês", included: true },
      { name: "Mentoria Mensal Inglês", included: true },
    ],
  },
];
